import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { ChatMessage } from 'src/types/chat'

type ChatState = {
	isOpen: boolean
	conversationId: string
	messagesByConversationId: Record<string, ChatMessage[]>
}

const initialState: ChatState = {
	isOpen: false,
	conversationId: 'default',
	messagesByConversationId: {},
}

const chatSlice = createSlice({
	name: 'chat',
	initialState,
	reducers: {
		openChat(state) {
			state.isOpen = true
		},
		closeChat(state) {
			state.isOpen = false
		},
		toggleChat(state) {
			state.isOpen = !state.isOpen
		},
		setConversationId(state, action: PayloadAction<string>) {
			state.conversationId = action.payload
		},
		appendMessage(
			state,
			action: PayloadAction<{
				conversationId: string
				message: ChatMessage
			}>
		) {
			const { conversationId, message } = action.payload
			const arr = state.messagesByConversationId[conversationId] ?? []
			state.messagesByConversationId[conversationId] = [...arr, message]
		},
		replaceMessages(
			state,
			action: PayloadAction<{
				conversationId: string
				messages: ChatMessage[]
			}>
		) {
			const { conversationId, messages } = action.payload
			state.messagesByConversationId[conversationId] = messages
		},
	},
})

export const {
	openChat,
	closeChat,
	toggleChat,
	setConversationId,
	appendMessage,
	replaceMessages,
} = chatSlice.actions
export default chatSlice.reducer
